import { UNEXPECTED_ERROR_MESSAGE } from '../constants/AppConstants'
import axios from 'axios'
import LogRocket from 'logrocket'
import { bugsnagClient, LOGROCKET_API_KEY } from '../constants/AppConstants'

export function promisify(func) {
  return (...args) =>
    new Promise((resolve, reject) => {
      const callback = (err, data) => (err ? reject(err) : resolve(data))
      func.apply(this, [...args, callback])
    })
}

export function asyncErrorHandler(e) {
  console.log(e)
}

export function extractAPIError(error) {
  let message = UNEXPECTED_ERROR_MESSAGE
  if (error.response && error.response.data && error.response.data.message) {
    message = error.response.data.message
  } else if (error.response && error.response.data && error.response.data.error) {
    message = error.response.data.error
  }
  return message
}

//taken from here https://stackoverflow.com/a/7592235/104380
export function capitalizeAllWords(input, lower) {
  return (lower ? input.toLowerCase() : input).replace(/(?:^|\s)\S/g, function(a) {
    return a.toUpperCase()
  })
}

export function setGlobalCSRF(response) {
  if (response && response.data && response.data.csrfToken) {
    axios.defaults.headers.common['CSRF-TOKEN'] = response.data.csrfToken
  }
}

export function notifyError(error) {
  if (LOGROCKET_API_KEY) {
    if (error instanceof Error) {
      LogRocket.captureException(error)
    } else {
      LogRocket.captureMessage(error)
    }
  }
  bugsnagClient.notify(error)
}



// WEBPACK FOOTER //
// ./src/utils/Util.js